import $ from "jquery";
import objectFitImages from "object-fit-images";
import svg4everybody from "svg4everybody";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "lazysizes";
import "picturefill";
import "responsive-bp";
import "slick-carousel";
import "@fancyapps/fancybox";

import uiHelpers from "./ui-helpers";

svg4everybody();
uiHelpers.init();
objectFitImages();

// include any plugin initialisation here
// any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins
$(".no-js").removeClass("no-js");

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

// Sticky header
let headerHeight = $(".primary-header").outerHeight();

if ($("#alert-message").length) {
  const alertHeight = $("#alert-message").outerHeight();
  headerHeight = headerHeight + alertHeight;
}

// Navigation
addListenersToNav();

$(window).resize(() => {
  addListenersToNav();
});

function addListenersToNav() {
  if ($(window).width() <= 1280) {
    // Unbind
    $(".js-menu-toggle").unbind("click");

    // Rebind
    $(".js-menu-toggle").on("click", e => {
      const thisEl = $(e.currentTarget);
      thisEl.toggleClass("active");
      $(".js-menu").toggleClass("active");
      e.preventDefault();
    });
  }
}

// Slick
$(".js-carousel").slick({
  arrows: true,
  responsive: [
    {
      breakpoint: 980,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
        dots: true,

        slidesToShow: 1
      }
    }
  ],
  slidesToShow: 3
});

$(".js-gallery-carousel").slick({
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ],
  slidesToScroll: 1,
  slidesToShow: 1
});

$(".js-slider").slick({
  arrows: true,
  dots: true
});

const faderOptions = {
  arrows: true,
  dots: true,
  fade: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false
      }
    }
  ]
};

$.each($(".js-fader"), function() {
  const carouselAutoplay = $(this).hasClass("hero--autoplay");
  $(this).slick({
    ...faderOptions,
    autoplay: carouselAutoplay,
    autoplaySpeed: 3000
  });
});

$(".js-fader-no-dots").slick({
  ...faderOptions,
  dots: false
});

$(".js-gallery-slider").slick({
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ],
  slidesToScroll: 1,
  slidesToShow: 1
});

// Accordions
const acc = document.getElementsByClassName("js-accordion");
let i: number;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    const panel = this.nextElementSibling;

    if (panel) {
      this.parentNode.classList.toggle("active");

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  });
}

// Tabbed content
$(".js-tab").on("click", e => {
  const thisEl = $(e.currentTarget);
  const index = thisEl.index() + 1;
  const tabList = thisEl.parent();
  const tabs = tabList.parent().next();

  thisEl
    .addClass("active")
    .siblings()
    .removeClass("active");
  tabs.find("> div").removeClass("active");
  tabs.find("> div:nth-child(" + index + ")").addClass("active");
  tabList.removeClass("open");
});

$(".js-mobile-tab").on("click", e => {
  const thisEl = $(e.currentTarget);
  const tabList = thisEl.next();
  tabList.toggleClass("open");
  e.preventDefault();
});

$.each($(".js-quotes-carousel"), function() {
  $(this).slick({
    arrows: true,
    dots: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false
        }
      }
    ],
    slidesToScroll: 1,
    slidesToShow: 1
  });
  const $status = $(this)
    .parent()
    .find(".js-quotes-paging");

  $(this).on("afterChange", function(event, slick, currentSlide, nextSlide) {
    $status.text(currentSlide + 1 + " / " + slick.slideCount);
  });
});

$(".js-nav-slider-basic").slick({
  centerMode: false,
  dots: false,
  infinite: true,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 6
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 5
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 501,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 3
      }
    }
  ],
  slidesToScroll: 1,
  slidesToShow: 7
});

// In-page nav slider
const initialSlideIndex = $(".js-nav-slider").data("initialslide");

$(".js-nav-slider").slick({
  asNavFor: ".nav-popup-slider",
  centerMode: false,
  dots: true,
  infinite: true,
  initialSlide: initialSlideIndex,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 5
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 501,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ],
  slidesToScroll: 1,
  slidesToShow: 7
});

// Popup slider
$(".nav-popup-slider").slick({
  arrows: false,
  asNavFor: ".nav-slider",
  dots: false,
  infinite: true,
  initialSlide: initialSlideIndex,
  slidesToScroll: 1,
  slidesToShow: 1
});

// Open popup if initialSlideIndex is supplied
if (initialSlideIndex >= 0) {
  $(".nav-popup").addClass("open");
}

// Open popup on slick
let currentSlide = 0;

$(".open-popup").click(function(e) {
  e.preventDefault();
  const slide = $(this).data("slide");

  // Check for same slide as currently open
  if (slide === currentSlide) {
    $(".nav-popup").removeClass("open");
    currentSlide = 0;
  } else {
    currentSlide = slide;
    $(".nav-popup-slider").slick("slickGoTo", slide - 1);
    $(".open-popup").removeClass("open");
    $(".nav-popup").addClass("open");
  }
});

$(".nav-popup__close").click(e => {
  e.preventDefault();
  $(".nav-popup").removeClass("open");
});

// Prevent the annoying animation when slides return to 1st slide
$(".nav-slider").on("beforeChange", (event, slick, currentSlide, nextSlide) => {
  const slidesLength = slick.$slides.length - 1;
  const isCurrentFirstOrLast =
    currentSlide === 0 || currentSlide === slidesLength;
  const isNextFirstOrLast = nextSlide === 0 || nextSlide === slidesLength;

  // guard against user tapping next slide but not moving it enough to qualify as a slide change
  if (currentSlide === nextSlide) {
    return;
  }

  if (isCurrentFirstOrLast && isNextFirstOrLast) {
    const nextClone = $(event.currentTarget).find(".slick-cloned.slick-active");
    setTimeout(() => {
      nextClone.addClass("slick-current");
      nextClone.prev().addClass("slick-active");
      nextClone.next().addClass("slick-active");
    }, 0);
  }
});

$(".js-venue-carousel").slick({
  arrows: true,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 501,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ],
  slidesToScroll: 1,
  slidesToShow: 3
});

// Venue Collection carousels
$(".js-venue-card-expand").on("click", e => {
  console.log("Test");
  e.preventDefault();
  const thisEl = $(e.currentTarget);
  const src = thisEl.data("src");
  const mediaCarousel = thisEl
    .parents(".venue-card")
    .find(".js-venue-media-carousel");

  $.fancybox.open({
    opts: {
      afterShow(instance, current) {
        mediaCarousel.slick({
          arrows: true,
          cssEase: "linear",
          dots: false,
          fade: true,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 1
        });
      }
    },
    src,
    type: "inline"
  });
});

// Nav tabs
$(".nav-tabs__list li a").click(e => {
  e.preventDefault();
});

$(".nav-tabs__list li").click(e => {
  const thisEl = $(e.currentTarget);
  const tabid = thisEl.find("a").attr("href");

  if (thisEl.hasClass("active")) {
    $(".nav-tabs__list li,.nav-tabs div.tab")
      .removeClass("active")
      .removeClass("nav-tabs__item--active"); // removing active class from tab
    $(".tab").hide(); // hiding open tab
    thisEl.removeClass("active").removeClass("nav-tabs__item--active"); // Removing active class from clicked tab
  } else {
    $(".nav-tabs__list li,.nav-tabs div.tab")
      .removeClass("active")
      .removeClass("nav-tabs__item--active"); // removing active class from tab

    $(".tab").hide(); // hiding open tab
    $(tabid).show(); // show tab
    thisEl.addClass("active"); // adding active class to clicked tab
  }
});

// Open menu on mobile slider nav
$(".nav-popup__more").click(e => {
  e.preventDefault();
  const thisEl = $(e.currentTarget);
  thisEl.toggleClass("open");
  $(".nav-popup__menus").slideToggle("slow");
});

// Open accordion (manager statement)
$(".accordion-quote__more").click(e => {
  e.preventDefault();
  const thisEl = $(e.currentTarget);
  thisEl.toggleClass("open");
  $(".accordion-quote__content").slideToggle("slow");
});

$(document).ready(() => {
  // Enable both toggle buttons to toggle menu
  $(".js-burger-toggle").click(() => {
    $(".js-burger-menu").toggleClass("is-visible");
    $("html").toggleClass("no-scroll");
  });

  // Check each burger menu links for sub-menus
  $(".burger-menu__link").each((index, value) => {
    const link = value;
    const href = $(value).attr("href");
    let hasChildren = false;

    // Check for children
    $(link.parentNode.childNodes).each((index, sibling) => {
      if ($(sibling).hasClass("burger-menu__menu")) {
        hasChildren = true;
      }

      if (hasChildren && sibling.nodeType !== 3) {
        // Add Overview link
        $(sibling).prepend(
          `<li class="burger-menu__item"><a href="${href}" class="burger-menu__link">Overview</a></li>`
        );

        link.classList.add("has-children");
        link.addEventListener("click", e => {
          e.preventDefault();
          const menu = document.querySelector(".js-burger-menu");
          if ($(menu).hasClass("second")) {
            $(menu).removeClass("second");
            $(menu).addClass("third");
          } else {
            $(menu).addClass("second");
          }
          $(sibling).addClass("is-open");
        });

        // Add Back link
        const div = document.createElement("li");
        $(div).addClass("burger-menu__item");
        const a = document.createElement("a");
        $(a).addClass("burger-menu__link");
        $(a).addClass("burger-menu__link--back");
        a.innerHTML = "Back";
        a.setAttribute("href", href);
        $(div).append(a);
        $(sibling).prepend(div);

        a.addEventListener("click", e => {
          e.preventDefault();
          const thisEl = $(e.currentTarget);
          const menu = document.querySelector(".js-burger-menu");
          if ($(menu).hasClass("third")) {
            $(menu).removeClass("third");
            $(menu).addClass("second");
          } else {
            $(menu).removeClass("second");
          }

          // Remove is open class after 150ms
          setTimeout(() => {
            thisEl.parents(".burger-menu__menu").removeClass("is-open");
          }, 150);
        });
      }
    });
  });
});

// Course status dropdown
$(".course-status__button").on("click", e => {
  const thisEl = $(e.currentTarget);
  thisEl.toggleClass("open");
  $(".course-status__dropdown").toggleClass("open");
  e.preventDefault();
});

// Video popup
$(".js-video-launch").on("click", e => {
  const thisEl = $(e.currentTarget);
  $(".js-video-modal")
    .addClass("open")
    .find(".js-video-iframe")
    .attr("src", thisEl.attr("href"));
  $("html").addClass("no-scroll");
  e.preventDefault();
});

$(".js-video-close").on("click", e => {
  $(".js-video-modal").removeClass("open");
  $(".js-video-iframe").each(function() {
    $(this).removeAttr("src");
  });
  $("html").removeClass("no-scroll");
  e.preventDefault();
});

// Clone Tripadvisor embed into footer
declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    taAddValidator: any;
  }
}

const taInterval = setInterval(taCheck, 2000);

function taCheck() {
  if (typeof window.taAddValidator === "function") {
    const taClone = $(".js-tripadvisor-source > div").clone();
    $(".js-tripadvisor-target").append(taClone);
    clearInterval(taInterval);
  }
}

// set timeout onDomReady
$(function() {
  setTimeout(delayedFragmentTargetOffset, 500);
});

// add scroll offset to fragment target (if there is one)
function delayedFragmentTargetOffset() {
  const offset = $(":target").offset();
  if (offset) {
    const scrollto = offset.top - 200; // minus fixed header height
    $("html, body").animate({ scrollTop: scrollto }, 0);
  }
}

// Top mobile menu (book dropdown)

$(".mobile-header__top__book").click(function(e) {
  e.preventDefault();
  $(this).toggleClass("open");
  $(".mobile-header__sub-menu").toggleClass("open");
  $(".mobile-header__mask").toggleClass("open");
  $(".mobile-header__featured-sub-menu").removeClass("open");
});

$(".mobile-header__top-featured").click(function(e) {
  e.preventDefault();
  $(this).toggleClass("open");
  $(".mobile-header__featured-sub-menu").toggleClass("open");
  $(".mobile-header__mask").toggleClass("open");
  $(".mobile-header__sub-menu").removeClass("open");
});

$(".mobile-header__mask").click(function(e) {
  e.preventDefault();
  $(this).toggleClass("open");
  $(".mobile-header__sub-menu").removeClass("open");
  $(".mobile-header__top__book").removeClass("open");
  $(".mobile-header__featured-sub-menu").removeClass("open");
});

/* Close menu using the escape key */
$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    if ($(".mobile-header__sub-menu").hasClass("open")) {
      $(".mobile-header__sub-menu").removeClass("open");
    }

    if ($(".mobile-header__top__book").hasClass("open")) {
      $(".mobile-header__top__book").removeClass("open");
    }
  }
});
